// types
import { createSlice } from '@reduxjs/toolkit';
import type { MenuState } from 'store/types';

// initial state
const initialState: MenuState = {
    openItem: ['dashboard'],
    defaultId: 'dashboard',
    openComponent: 'buttons',
    drawerOpen: false,
    userMenuOpen: false,
    componentDrawerOpen: true,
    showQLiveGradient: false,
    extensions: {
        enabled: [],
        endpoints: [],
    },
};

// ==============================|| SLICE - MENU ||============================== //

const menu = createSlice({
    name: 'menu',
    initialState,
    reducers: {
        activeItem(state, action) {
            state.openItem = action.payload.openItem;
        },

        activeComponent(state, action) {
            state.openComponent = action.payload.openComponent;
        },

        openDrawer(state, action) {
            state.drawerOpen = action.payload.drawerOpen;
        },

        openUserMenu(state, action) {
            state.userMenuOpen = action.payload.userMenuOpen;
        },

        openComponentDrawer(state, action) {
            state.componentDrawerOpen = action.payload.componentDrawerOpen;
        },

        extensionEnabled(state, action) {
            const key = action.payload.name;
            if (!state.extensions.enabled?.includes(key)) {
                state.extensions.enabled!.push(key);
            }
        },

        addExtensionEndpoint(state, action) {
            if (!state.extensions.endpoints) {
                state.extensions.endpoints = [];
            }
            if (!state.extensions.endpoints.includes(action.payload)) {
                state.extensions.endpoints.push(action.payload);
            }
        },

        clearExtensions(state) {
            state.extensions = initialState.extensions;
        },

        enableQLiveGradient(state, action) {
            state.showQLiveGradient = true;
        },

        disableQLiveGradient(state, action) {
            state.showQLiveGradient = false;
        },
    },
});

export default menu.reducer;

export const {
    activeItem,
    activeComponent,
    openDrawer,
    openUserMenu,
    openComponentDrawer,
    extensionEnabled,
    addExtensionEndpoint,
    clearExtensions,
    enableQLiveGradient,
    disableQLiveGradient,
} = menu.actions;
